<template>
  <div
    id="import-my-holder-address-modal"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-[550px] max-h-full">
      <div class="relative bg-gray-700 rounded-lg shadow">
        <div
          class="flex items-center justify-between px-4 py-2 border-b border-gray-600 rounded-t"
        >
          <h3 class="font-semibold text-base uppercase">
            Import my holder address
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent rounded-lg text-sm w-6 h-6 ms-auto inline-flex justify-center items-center hover:bg-gray-600 hover:text-white"
            @click="this.modal.hide()"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
        <div class="p-4 space-y-4">
          <div
            class="p-2 text-sm rounded-lg bg-gray-800 text-yellow-300"
            role="alert"
            v-if="this.mgs"
            v-html="this.mgs"
          ></div>
          <textarea
            v-model="inputModel"
            rows="8"
            class="p-2.5 w-full text-sm bg-transparent rounded-xl border border-gray-400 focus:outline-none"
            :placeholder="`Address 1\nAddress 2\nAddress 3\n...`"
          ></textarea>
          <div class="mt-6 flex justify-end">
            <div
              class="inline-block bg-gray-700 shadow shadow-blue-500 hover:shadow-blue-400 px-5 py-1.5 text-sm font-bold rounded-xl cursor-pointer text-gray-200"
              @click="this.submit"
            >
              Import
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "flowbite";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ImportMyHolderAddressModal",
  props: {
    open: Boolean,
    myHolderWallet: Array,
  },
  data() {
    return {
      modal: null,
      inputModel: "",
      mgs: null,
    };
  },
  computed: {
    ...mapGetters("wallet", ["network"]),
  },
  watch: {
    open() {
      if (this.open === true) {
        this.inputModel = this.myHolderWallet
          .map((wallet) => `${wallet.address}`)
          .join("\n");
        this.mgs = "";
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
  methods: {
    ...mapActions("network", ["updateLocalStorage"]),
    submit() {
      const addresses = this.inputModel
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line);
      const wallets = addresses.map((address) => ({ address }));
      this.updateLocalStorage({ myHolderWallet: wallets });
      this.$store.commit("toast/add", {
        type: "success",
        title: `${wallets.length} wallets have been successfully imported!`,
      });
      this.$parent.myHolderWallet = wallets;
    },
  },
  mounted() {
    this.modal = new Modal(
      document.getElementById("import-my-holder-address-modal"),
      {
        placement: "center",
        backdropClasses:
          "bg-gray-900 bg-opacity-50 bg-opacity-80 fixed inset-0 z-40",
        onHide: () => {
          this.$parent.openImportMyHolderAddressModal = false;
        },
      }
    );
  },
  beforeUnmount() {
    this.$parent.openImportMyHolderAddressModal = false;
  },
};
</script>
